import { Typography, Box, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { Link } from 'react-router-dom';
import CodeBlock from '../CodeBlock';

function Authentication() {
  return (
    <Box sx={{ textAlign: 'left' }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Secure, Simple API Authentication
      </Typography>
      
      <Typography variant="body1" sx={{ mb: 2 }}>
        Our API authentication system uses industry-standard token-based authentication to provide 
        a seamless and secure experience for your EUDR reporting needs. With our straightforward 
        API key system, you can easily integrate our services into your applications while 
        maintaining full control over access permissions. ✨
      </Typography>
      
      <Typography variant="body1" sx={{ mb: 2 }}>
        By using API keys instead of your actual EUDR credentials in each request, we add an 
        extra layer of security to your integration. You can create multiple keys with different 
        expiration dates, revoke them at any time, and monitor their usage - giving you complete 
        visibility and control over your API access. 🔐
      </Typography>

      <Typography variant="body1">
        All API requests require an API key to be included in the request headers.
      </Typography>

      <Typography variant="h6" sx={{ mt: 2 }}>
        Request Headers
      </Typography>
      <CodeBlock
        code={`Authorization: Bearer YOUR_TOKEN`}
      />

      <Typography variant="body1" sx={{ mt: 2 }}>
        Authentication tokens can be created for either the Acceptance (Test) EUDR environment or Production environment.
        Each token is tied to your EUDR credentials and will only work if you have properly configured EUDR credentials in your profile.
      </Typography>

      <Typography variant="body1" sx={{ mt: 2 }}>
        The number of API keys you can create depends on your subscription plan. Check our <Link to="/pricing" underline="hover">pricing page</Link> for additional options and plan details.
      </Typography>

      <Typography variant="body1" sx={{ mt: 2 }}>
        You can create and manage your API keys from the <Link to="/dashboard" underline="hover">API Keys Dashboard</Link>.
      </Typography>

      <Typography variant="h6" sx={{ mt: 3 }}>
        Authentication Errors
      </Typography>
 
      <TableContainer component={Paper} sx={{ mt: 1 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Code</TableCell>
              <TableCell>Condition</TableCell>
              <TableCell>Resolution</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>401</TableCell>
              <TableCell>Unauthorized - Missing or invalid API key</TableCell>
              <TableCell>Verify API key and headers</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>403</TableCell>
              <TableCell>Forbidden - User account doesn't have EUDR credentials configured</TableCell>
              <TableCell>Configure EUDR credentials in your profile</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default Authentication; 